export default "__VITE_ASSET__CNYsDY6r__"